<script>
	import Project from "./App.svelte";
	import About from "./About.svelte";
	
	 export let nav = "home";

  let class1, class2;
  $: {
    if (nav) {
      if (nav === "Project") {
        class1 = "topnav-active";
      } else {
        class1 = "";
      }
      if (nav === "About") {
        class2 = "topnav-active";
      } else {
        class2 = "";
      }
    }
  }
</script>

<main>
  <ul class="topnav">
    <a href="/" on:click|preventDefault={() => (nav = 'project')} class={class1}>
      Project
    </a>
    <a href="/" on:click|preventDefault={() => (nav = 'about')} class={class2}>
      About
    </a>
  </ul>

  {#if nav === 'project'}
    <Project />
  {:else if nav === 'about'}
    <About />
  {/if}
</main>

<style>
  .topnav {
    background-color: #ff585d;
    overflow: hidden;
    margin-bottom: 0;
    border: 0;
  }
  /* Style the links inside the navigation bar */
  .topnav a {
    float: left;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
  }
  /* Change the color of links on hover */
  .topnav a:hover {
    color: rgb(124, 124, 124);
  }
  /* Add a color to the active/current link */
  .topnav-active {
    background-color: #9bd0d5;
    color: white;
  }
</style>